import { h } from '@stencil/core';
import { isBrowser } from '../../../globals/utils';
export class QuickActions {
  constructor() {
    this.handleAddToMyProductsClick = (event) => {
      this.addToMyProductsButtonDidClick.emit({
        initialEvent: event,
        isStickyBar: this.isStickyBar,
      });
    };
    this.productId = undefined;
    this.showCompare = undefined;
    this.showFavorites = false;
    this.hideOnTablet = true;
    this.addToMyProductsLabel = undefined;
    this.removeFromMyProductsLabel = undefined;
    this.compareLabel = undefined;
    this.compareLimitLabel = undefined;
    this.isInFavorites = false;
    this.isStickyBar = undefined;
    this.isCta = undefined;
    this.bazaarVoiceInfo = undefined;
  }
  renderFavoritesBtn() {
    if (isBrowser()) {
      const addToMyProducts = this.showFavorites
        && this.addToMyProductsLabel
        && this.removeFromMyProductsLabel;
      return (addToMyProducts && (h("pes-favorites-button", { class: this.hideOnTablet && 'favorite-btn', addLabel: this.addToMyProductsLabel, removeLabel: this.removeFromMyProductsLabel, isInList: this.isInFavorites, onClick: this.handleAddToMyProductsClick })));
    }
  }
  renderCompareControl() {
    if (!this.showCompare || !this.compareLabel) {
      return null;
    }
    return (h("pes-compare-control", { class: "compare-control", label: this.compareLabel, productId: this.productId }));
  }
  renderRatings() {
    return (h("bazaar-voice-rating", { class: "bazaar-voice-rating", productId: this.productId, bazaarVoiceInfo: this.bazaarVoiceInfo }));
  }
  render() {
    var _a;
    return (h("div", { class: { 'quick-actions-wrapper': true, 'quick-actions--is-cta': this.isCta } }, ((_a = this.bazaarVoiceInfo) === null || _a === void 0 ? void 0 : _a.enabled) && this.renderRatings(), h("div", { class: { 'quick-actions': true, 'quick-actions--is-cta': this.isCta } }, this.renderFavoritesBtn(), this.renderCompareControl())));
  }
  static get is() { return "pes-quick-actions"; }
  static get originalStyleUrls() {
    return {
      "$": ["quick-actions.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["quick-actions.css"]
    };
  }
  static get properties() {
    return {
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-compare",
        "reflect": false
      },
      "showFavorites": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-favorites",
        "reflect": false,
        "defaultValue": "false"
      },
      "hideOnTablet": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "hide-on-tablet",
        "reflect": false,
        "defaultValue": "true"
      },
      "addToMyProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "add-to-my-products-label",
        "reflect": false
      },
      "removeFromMyProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "remove-from-my-products-label",
        "reflect": false
      },
      "compareLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "compare-label",
        "reflect": false
      },
      "compareLimitLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "compare-limit-label",
        "reflect": false
      },
      "isInFavorites": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-in-favorites",
        "reflect": false,
        "defaultValue": "false"
      },
      "isStickyBar": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-sticky-bar",
        "reflect": false
      },
      "isCta": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-cta",
        "reflect": false
      },
      "bazaarVoiceInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TBazaarVoiceInfo",
          "resolved": "{ enabled: boolean; scriptUrl: string; }",
          "references": {
            "TBazaarVoiceInfo": {
              "location": "import",
              "path": "../bazaar-voice-rating/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get events() {
    return [{
        "method": "addToMyProductsButtonDidClick",
        "name": "addToMyProductsButtonDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "TAddToCartButtonEvent",
          "resolved": "{ initialEvent: MouseEvent; isStickyBar?: boolean; }",
          "references": {
            "TAddToCartButtonEvent": {
              "location": "import",
              "path": "../cta-area-se-container/types"
            }
          }
        }
      }];
  }
}
